<div dir="ltr" class="audio-player">

    <!-- Stop Button -->
    <button (click)="stop()">
        <i class="fa fa-stop"></i>
    </button>
    
    <!-- Play Button -->
    <button (click)="play()" *ngIf="!isPlaying">
        <i class="fa fa-play"></i>
    </button>

    <!-- Pause Button -->
    <button (click)="pause()" *ngIf="isPlaying">
        <i class="fa fa-pause"></i>
    </button>

    <!-- Playback Speed Selector -->
    <div class="speed-control">
        <select id="speed" [(ngModel)]="audio.playbackRate">
            <option *ngFor="let speed of [0.5, 1.0, 1.5, 2.0]" [value]="speed">{{ speed }}x</option>
        </select>
    </div>

<!-- Time & Progress Bar -->
    <div class="progress-container">
        <span>{{ currentTime }}</span>
        <input type="range" min="0" max="100" [value]="progress" (input)="seek($event)">
        <span>{{ duration }}</span>
    </div>

    <!-- Download Button -->
    <button (click)="download()">
        <i class="fa fa-download"></i>
    </button>

</div>